import { render, staticRenderFns } from "./SectionProfileSettings.vue?vue&type=template&id=4b3cc18b&scoped=true"
import script from "./SectionProfileSettings.vue?vue&type=script&lang=ts"
export * from "./SectionProfileSettings.vue?vue&type=script&lang=ts"
import style0 from "./SectionProfileSettings.vue?vue&type=style&index=0&id=4b3cc18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3cc18b",
  null
  
)

export default component.exports